import { useEffect, type ReactNode } from "react";

import { api, getToken, setToken } from "@/lib/api";
import type { MeResponse } from "@/lib/types";
import { useAuthStore } from "@/store/auth";

export function AuthProvider({ children }: { children: ReactNode }) {
  const setSession = useAuthStore((s) => s.setSession);
  const markLoaded = useAuthStore((s) => s.markLoaded);

  useEffect(() => {
    const token = getToken();
    if (!token) {
      markLoaded();
      return;
    }
    api
      .get<MeResponse>("/auth/me")
      .then((res) =>
        setSession({
          user: res.data.user,
          tenant: res.data.tenant,
          memberships: res.data.memberships,
          profileComplete: res.data.profile_complete,
        }),
      )
      .catch(() => {
        setToken(null);
        markLoaded();
      });
  }, [setSession, markLoaded]);

  return <>{children}</>;
}
